import nodesThatShouldChange from "./nodesThatShouldChange";
import { WidthResizeContext, NodeBoundsContext } from './Contexts';
import { useState, useContext, useRef } from 'react';
import { useMemo } from 'react';
import { DragInterfaceContext } from './MouseDragProvider';
import A from './ActionCreators';
import { SelectedItemsRefContext } from './SelectedItemProvider';
import getChangesByCellLocation from './getChangesByCellLocation';
import { useStore,useDispatch } from 'react-redux';
import { useFigurePanelId } from './FigurePanelIdProvider';


const resizeHandleThickness = 5;
const allResizeProps = {
  zIndex:100,
  position:'absolute',
  pointerEvents:'auto',
}


function computeFinalDim({w,h,dw=0,dh=0}){

  let aspect = w/h;

  if( dw === 0 && dh === 0 ){
    return { w, h };
  }

  if( dw !== 0 && dh !== 0 ){
    if( w > h ){
      dh = 0;
    }else if( h >= w ){
      dw = 0;
    }
  }

  if( dw === 0 && dh !== 0 ){

    return {
      w: aspect * (h + dh),
      h: h + dh
    }

  }else if( dw !== 0 && dh === 0 ){
    return {
      w: w + dw,
      h: (w + dw) / aspect
    }
  }else if( dw !== 0 && dh !== 0 ){
    return {
      w,
      h
    }
  }


}



const resizeHandles = [
  {top:-resizeHandleThickness,left:0,width:'100%', height:resizeHandleThickness, cursor:'ns-resize',resizeFrom:"top"},
  {bottom:-resizeHandleThickness,left:0,width:'100%', height:resizeHandleThickness, cursor:'ns-resize',resizeFrom:"bottom"},
  {top:0, left:-resizeHandleThickness, height:'100%', width:resizeHandleThickness, cursor:'ew-resize', resizeFrom:"left"}, 
  {top:0, right:-resizeHandleThickness, height:'100%', width:resizeHandleThickness,cursor:'ew-resize', resizeFrom:"right"}, 



  //need corner resizers
  // tl corner
  // tr corner
  // br corner
  // bl corner
].map(x => ({...x, ...allResizeProps}));

const [topHandle,bottomHandle,leftHandle,rightHandle] = resizeHandles;

const handlesByPosition = {
  tl:[bottomHandle, rightHandle],
  tr:[bottomHandle, leftHandle],
  tm:[bottomHandle, rightHandle, leftHandle],


  bl:[topHandle, rightHandle],
  br:[topHandle, leftHandle],
  bm:[bottomHandle,rightHandle,leftHandle],


  ml:[topHandle,rightHandle,bottomHandle],
  mm:resizeHandles,
  mr:[topHandle,leftHandle,bottomHandle],

}


/*

    The surrounding node is required
    as it will simply expand around the 
    eventual child.

    And we use that to get the dimensions of
    node above it.

*/

export default function NodeResizer({setChanges,children,node,parentBox,cellLocation,nodeId,
  nodePositionDragging,
}){

  const figurePanelId = useFigurePanelId();

  const selectedItemsRef = useContext(SelectedItemsRefContext);
  const dispatch = useDispatch();
  const dragInterface = useContext(DragInterfaceContext);

  let thisNodeLocator = {cellLocation,nodeId}; 

  const store = useStore();



  const onMouseDownCapture = useMemo(() => {
    return startFrom => e => {


      e.preventDefault();
      e.stopPropagation();


      let subregionDiv = e.target.parentNode;
      let startingBounds = subregionDiv.getBoundingClientRect();


      let targetLocations = nodesThatShouldChange(
        thisNodeLocator,
        selectedItemsRef.getState()?.expansionNodes || [],
        store.getState(),
        figurePanelId
      );

      console.log("targetLocations");
      console.log(targetLocations);

      console.log("NODE")
      console.log(node);

      dragInterface?.startDrag?.({
        event:e,
        onMouseMove:(start,end,info) => {

          console.log("STARTFROM: " + info.startFrom);
          console.log(node);

          if( ["bottom","top"].includes(info.startFrom) ){
            let {top,height} = startingBounds;
            let nodeBottom = (top + height);

            let newH = ({
              top:nodeBottom - end[1],
              bottom:(end[1]-top)
            })[ info.startFrom ];

            let dh = newH - (height + resizeHandleThickness);
            console.log({newH,dh,resizeHandleThickness,height})

            let {w,h} = computeFinalDim({
              w:startingBounds.width,
              h:startingBounds.height,
              dw:0,
              dh
            })

            setChanges({
              value:{
                widthProportionOfParent:(w/parentBox.width)
              }
            })
          }else if( ["left","right"].includes(info.startFrom) ){


            let {top,height,left,width } = startingBounds;
            let nodeRight = (left + width);

            let newW = ({
              left:nodeRight - end[0],
              right:(end[0]-left)
            })[ info.startFrom ]



            let dw = newW - width - resizeHandleThickness;
            console.log({newW,dw})

            let {w,h} = computeFinalDim({
              w:startingBounds.width,
              h:startingBounds.height,
              dw,
              dh:0
            })

            setChanges({
              value:{
                widthProportionOfParent:(w/parentBox.width)
              }
            })
          }

        },
        onDragEnd:(start,end,info,endEvent) => { 

          let deltaY = Math.abs(end[1] - start[1]);
          if( deltaY < 2 ){
            return;
          }

          let widthProportionOfParent;

          if( ["bottom","top"].includes(info.startFrom) ){
            let {top,height} = startingBounds;
            let nodeBottom = (top + height);

            let newH = ({
              top:nodeBottom - end[1],
              bottom:(end[1]-top)
            })[ info.startFrom ];

            let dh = newH - (height + resizeHandleThickness);
            console.log({newH,dh,resizeHandleThickness,height})

            let {w,h} = computeFinalDim({
              w:startingBounds.width,
              h:startingBounds.height,
              dw:0,
              dh
            })

            widthProportionOfParent = w/parentBox.width;
            
          }else if( ["left","right"].includes(info.startFrom) ){


            let {top,height,left,width } = startingBounds;
            let nodeRight = (left + width);

            let newW = ({
              left:nodeRight - end[0],
              right:(left - end[0])
            })[ info.startFrom ]



            let dw = newW - width - resizeHandleThickness;
            console.log({newW,dw})

            let {w,h} = computeFinalDim({
              w:startingBounds.width,
              h:startingBounds.height,
              dw,
              dh:0
            })

            widthProportionOfParent = w/parentBox.width;
            
          }

          debugger;


          let byCellLocation = getChangesByCellLocation({
            targetLocations,
            properties:{
              widthProportionOfParent,
            }
          })

          setChanges();

          dispatch(A.setCellsValueProperties({
            figurePanelId,
            byCellLocation

          }))



        },
        //e,
        startFrom,
        startingBounds,
        targetLocations
      })

    }
  },[thisNodeLocator,node])


  const basePosition = node?.position?.base; 
  const handlesToRender = handlesByPosition[ basePosition ] || resizeHandles;


  return (
    <div class="rel">
      {!nodePositionDragging && handlesToRender.map(divProps => {
        return (
          <div
            onClickCapture={e => e.stopPropagation()}
            onMouseDownCapture={onMouseDownCapture(divProps.resizeFrom)} 
            class="bg-blue-on-hover" 
            style={divProps}
          />

        )
      })}
      {children}
    </div>
  )





}
